// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__OaGBF","label":"Radio_label__YpL2d","checkMark":"Radio_checkMark__1pxBc","disabled":"Radio_disabled__co54j"};